import React, { useContext } from "react";
import { LanguageContext, text } from "../../../container/language";

const Image = ({ data }) => {
    const { image: { url }, description } = data
    const { userLanguage } = useContext(LanguageContext)

    return (
        <div className="text">
            <p>
                <img src={url} caption="false" />
            </p>
            <p>
                <small>
                    <font>
                        {text(description, userLanguage)}
                    </font>
                </small>
            </p>
        </div>
    )
}

export default Image;